module.exports = __webpack_public_path__ + "img/advantage_one.c5b02f7f.png";